import styled from 'styled-components';
import { getColor } from '../../../../../../constants/skillLevels';

export const SkillLevelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 200px;
`;

export const HeaderSection = styled.div`
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  margin-bottom: 8px;
`;

export const SkillName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
`;

export const SkillLevelBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SkillLevelOption = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${props => props.$isSelected ? getColor(props.$levelId, props.$skillLevels) : 'transparent'};
  border: 1px solid ${props => getColor(props.$levelId, props.$skillLevels)};
  opacity: ${props => props.$isSelected ? 1 : 0.7};

  &:hover {
    opacity: 1;
    background-color: ${props => getColor(props.$levelId, props.$skillLevels)};
  }
`;

export const LevelName = styled.span`
  font-size: 13px;
  color: ${props => props.$isSelected ? '#000' : '#666'};
  flex: 1;
`;

export const SkillLevelDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${props => getColor(props.$levelId, props.$skillLevels)};
  border: 1px solid ${props => props.$isSelected ? '#333' : 'transparent'};
`; 

export const TooltipContent = styled.div`
  font-size: 12px;
  line-height: 1.5;
  max-width: 300px;
  padding: 4px 0;
`;

export const LoadingIndicator = styled.div`
  height: 2px;
  width: 100%;
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;
  margin-bottom: 8px;
  
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 30%;
    background-color: #ddd;
    animation: loading 1.5s infinite;
  }
  
  @keyframes loading {
    0% { left: -30%; }
    100% { left: 100%; }
  }
`;